module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-font-fill-b0b5d712.svg";